'use strict';

var SponsorshipPanelDirective = function SponsorshipPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/sponsorship-panel-flight.html'),
    controller: 'SponsorshipFlightPanelController',
    link: function link(scope, element) {
      var SPONSORED_DROP_DOWN_ID_SUFFIX = '-sponsored-drop-down';
      var SPONSORED_PANEL_ID_SUFFIX = '-selected-flight-chart';
      scope.togglePanel = function (show) {
        scope.expanded = show;
        element.find('#' + scope.uniqueId).collapse(show ? 'show' : 'hide');
      };
      function getElement(idSuffix) {
        return element.find('#' + scope.uniqueId + idSuffix);
      }
      function toggleHideElement(show, ele) {
        if (show) {
          ele.show();
        } else {
          ele.hide();
        }
      }
      scope.toggleHide = function (show, idSuffix) {
        var ele = getElement(idSuffix);
        toggleHideElement(show, ele);
      };
      scope.collapse = scope.togglePanel.bind(scope, false);
      scope.uncollapse = scope.togglePanel.bind(scope, true);
      scope.hideSponsoredDropDown = scope.toggleHide.bind(scope, false, SPONSORED_DROP_DOWN_ID_SUFFIX);
      scope.showSponsoredDropDown = scope.toggleHide.bind(scope, true, SPONSORED_DROP_DOWN_ID_SUFFIX);
      scope.hideSelectedFlightChart = scope.toggleHide.bind(scope, false, SPONSORED_PANEL_ID_SUFFIX);
      scope.showSelectedFlightChart = scope.toggleHide.bind(scope, true, SPONSORED_PANEL_ID_SUFFIX);
      scope.hideSponsor = function () {
        scope.hideSponsoredDropDown();
        scope.hideSelectedFlightChart();
        scope.isUnderReview = true;
      };
      scope.showSponsor = function () {
        scope.showSponsoredDropDown();
        scope.showSelectedFlightChart();
        scope.isUnderReview = false;
      };
    }
  };
};
SponsorshipPanelDirective.$inject = [];
module.exports = SponsorshipPanelDirective;